var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-container"},[_c('d-header',{attrs:{"fluid":"","actions":[
      {
        label: _vm.$t('add_constat'),
        resource: 'propertyInspection',
        primary: true,
        color: 'is-primary',
        action: _vm.openCreate,
      },
    ],"breadcrumbs":false}},[_c('h3',{staticClass:"title is-4"},[_vm._v("\n      "+_vm._s(_vm.$t("property_inspections").capitalize())+"\n    ")])]),_vm._v(" "),_c('v-works-table',{ref:"works",attrs:{"property-id":_vm.model.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }